"use client";

import { ShortcodeRenderer } from "@/components/ShortcodeRenderer";

interface WhitelabelHomepageProps {
  homepageHtml: string;
  tenant: {
    name: string;
    headerSticky?: boolean;
    headerTransparentInitial?: boolean;
    footerTransparentOnHomepage?: boolean;
  };
}

/**
 * Client component for rendering custom homepage HTML in whitelabel mode.
 * CSS theme variables are applied by ThemeProvider in the root layout —
 * this component only handles layout concerns and content rendering.
 */
export function WhitelabelHomepage({ homepageHtml, tenant }: WhitelabelHomepageProps) {

  // When header is sticky AND transparent initial is enabled, use negative margin
  // to allow content to extend under the transparent header on the homepage
  const shouldExtendUnderHeader = tenant.headerSticky && tenant.headerTransparentInitial;
  const heroMarginClass = shouldExtendUnderHeader ? '-mt-16 pt-16' : '';

  // When footerTransparentOnHomepage is enabled, make the background transparent
  // so the LayoutWrapper's background image shows through behind the footer
  const useTransparentBackground = tenant.footerTransparentOnHomepage;

  return (
    <div
      className={`whitelabel-homepage ${heroMarginClass} flex-1`}
      style={{
        backgroundColor: useTransparentBackground ? 'transparent' : 'var(--theme-bg, #FFFFFF)',
        color: 'var(--theme-text, #111827)',
        minHeight: useTransparentBackground ? undefined : '100vh',
      }}
    >
      <ShortcodeRenderer
        content={homepageHtml}
        className="whitelabel-content"
      />
    </div>
  );
}
